module.exports = __webpack_public_path__ + "static/media/bb.3fb12ea5.svg";